import { Plane, Heart, Users, FileCheck, Ticket } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";

const services = [
  {
    icon: Ticket,
    title: "Air Ticket Booking",
    description: "Domestic & international flights at competitive rates with 24/7 support.",
  },
  {
    icon: Plane,
    title: "Holiday Packages",
    description: "Curated travel packages for all destinations with complete planning.",
  },
  {
    icon: Heart,
    title: "Honeymoon & Couple Tours",
    description: "Romantic getaways designed to create magical memories for newlyweds.",
  },
  {
    icon: FileCheck,
    title: "Visa & Travel Assistance",
    description: "Expert visa assistance with end-to-end documentation support.",
  },
  {
    icon: Users,
    title: "Group & Family Tours",
    description: "Perfect vacations for groups with activities for all ages and interests.",
  },
];

export const CoreServices = () => {
  return (
    <section className="section-padding bg-background" aria-labelledby="core-services-heading">
      <div className="container-luxury">
        <div className="text-center space-y-4 mb-14">
          <span className="section-badge">What We Offer</span>
          <h2 id="core-services-heading" className="section-title">
            Our Core Services
          </h2>
          <p className="section-subtitle">
            Comprehensive travel solutions designed to make your journey seamless and memorable.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="luxury-card p-8 space-y-5 hover-lift group"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary transition-colors duration-300">
                <service.icon className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors duration-300" aria-hidden="true" />
              </div>
              <h3 className="font-heading font-semibold text-xl">{service.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <Button size="lg" asChild className="px-8 rounded-full h-12 font-semibold">
            <NavLink to="/services">
              View All Services
            </NavLink>
          </Button>
        </div>
      </div>
    </section>
  );
};